import React from 'react';

const Reset = ({score, onRestart, totalQuestions, skiped}) =>{
    return (
        <div className="result">
            <h2>Test zakończony</h2>
            <p>Twój wynik to: {score}/{totalQuestions}</p>
            <p>{Math.floor((score/totalQuestions)*100)}%</p>
            {Math.floor((score/totalQuestions)*100)>=60? <p className="git">🎉 ZDANE 🎉</p> : <p className="niegit">NIE ZDANE</p> }
            <br/>
            <p>Ilość pominiętych pytań: {skiped}</p>
            <br/>
            <button onClick={onRestart} className="restart">Ja chce jeszcze raz!</button>
        </div>
    )
};
export default Reset;